import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography, Divider} from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';


export default function PackagingInfo() {
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);

  return (
      <Grid sx={{ backgroundColor: 'white', borderRadius: 2, m:1, p:1, }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold', }}>
          Packaging Information
        </Typography>
        <Divider sx={{ borderStyle: 'dotted',  }} />
        <Grid container direction="row" sx={{ width: '100%' }}>
          <Grid item  lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Boxe(s)" value={productObj?.batchsize || "-"} /></Grid>
          <Grid item lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Format" value={productObj.packagingtypename} /></Grid>
          <Grid item lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Packaging Material" value={productObj?.packagingtypename || "-"} /></Grid>
          {
            productObj.formname==="Syrup" ||
            productObj.formname==="Drop" ||
            productObj.formname==="Gargle" ||
            productObj.formname==="Lotion"
            ?<Grid item lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Packaging" value={productObj.packagingsize2name+ " ml"} /></Grid>:
          <Grid item lg={6} md={6} sm={6} xs={6} ><FieldView2 label="Box Packaging" value={productObj.packagingtext} /></Grid>
  }
          
        </Grid>
      </Grid>
  );
}